// extracted by mini-css-extract-plugin
module.exports = {"main":"_3mzZd70jC7G7PJ_yVxq2RI"};